export default __webpack_public_path__ + "src/assets/images/plug/smartplug_US.png?212129db";